module.exports = __webpack_public_path__ + "static/media/sample-kit3.6c076618.jpg";